import getLongCenterAlignedTexts from './getLongCenterAlignedTexts';
import wordComplexity from './wordComplexity';
import keyphraseDistribution from './keyphraseDistribution';

export {getLongCenterAlignedTexts, keyphraseDistribution, wordComplexity};
